export default {
    practiceTitle:"Practice Center",
    practiceDescription:"Sharpen your language skills with focused exercises",
    practiceTestLabel:"Practice Tests",
    progressLabel:"Progress",
}